import { useEffect, useRef, useState } from "react"
import { closeIcon } from "../../icons"
import API from "../../api"
import "./contact-form-modal.component.css"

const SUBJECTS = ["General Inquiry", "New Business", "Press"]

const ContactFormModal = (props) => {
  const { onClose, defaultSubject } = props
  const elRef = useRef()
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [subject, setSubject] = useState(defaultSubject || SUBJECTS[0])
  const [message, setMessage] = useState("")
  const [submitting, setSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!elRef.current) return
    setTimeout(() => elRef.current.classList.add("active"))
  }, [])

  const handleClose = () => {
    elRef.current.classList.remove("active")
    setTimeout(onClose, 300)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSubmitting(true)
    setError(false)

    try {
      await API.submitContactForm({
        Name: name,
        Email: email,
        Subject: subject,
        Message: message,
      })
      setSubmitted(true)
    } catch (err) {
      setError(true)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="dagger-contact-modal" onClick={handleClose}>
      <div
        className="dagger-contact-modal-content"
        ref={elRef}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="dagger-close-btn" onClick={handleClose}>
          {closeIcon}
        </button>

        {submitted ? (
          <div className="dagger-contact-modal-success">
            <h2>Thank you</h2>
            <p>Your message has been sent. We'll be in touch soon.</p>
            <button className="dagger-outline-btn" onClick={handleClose}>
              Close
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="dagger-contact-modal-form">
            <h2>Get in Touch</h2>
            <div className="dagger-contact-modal-fields">
              <input
                type="text"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <select
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                required
              >
                {SUBJECTS.map((s) => (
                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
              </select>
              <textarea
                placeholder="Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={5}
                required
              />
            </div>
            {error && (
              <div className="dagger-contact-modal-error">
                Something went wrong. Please try again.
              </div>
            )}
            <button
              type="submit"
              className="dagger-outline-btn"
              disabled={submitting}
            >
              {submitting ? "Sending..." : "Send Message"}
            </button>
          </form>
        )}
      </div>
    </div>
  )
}

export default ContactFormModal
